import _ from 'lodash';

// sort order list
export function SortListOrder(sortName, list = [], order) {
  var listSort =  _.orderBy(list, [sortName], order)
  return listSort
}


// WEBPACK FOOTER //
// ./src/actions/datatable.js